import { show, hide } from 'redux-modal'
import { SUCCESSFUL_SUBMIT_MODAL } from './constants'

export const showSuccessfulSubmitModal = ({ onConfirm, confirmButtonText, description }) =>
  show(SUCCESSFUL_SUBMIT_MODAL, { onConfirm, confirmButtonText, description })

export const hideSuccessfulSubmitModal = () => hide(SUCCESSFUL_SUBMIT_MODAL)

